__turbopack_context__.v({
  "action": "hairColorDemo-module__pxMxwq__action",
  "caption": "hairColorDemo-module__pxMxwq__caption",
  "comparison": "hairColorDemo-module__pxMxwq__comparison",
  "demo": "hairColorDemo-module__pxMxwq__demo",
  "heading": "hairColorDemo-module__pxMxwq__heading",
  "hint": "hairColorDemo-module__pxMxwq__hint",
  "shades": "hairColorDemo-module__pxMxwq__shades",
});
